import request from '@/utils/request'
import { uuid } from 'vue-uuid';
import { obj2query } from '@/utils'
import { getToken } from '@/utils/auth'

export function getIntroducer(query){
  return request({
    url: `/api/introducers${obj2query(query)}`,
    method: "get"
  });
}
export function getIntroducerByProject(project_uid, query){
  let queryStr = query ? obj2query(query) : "";
  return request({
    url: `/api/introducers/${project_uid}${queryStr}`,
    method: "get"
  });
}

export function postIntroducer(data){
  data.idempotency = uuid.v1()
  return request({
    url: `/api/introducers/${uuid.v1()}`,
    method: "post",
    data: data
  });
}

export function updateIntroducer(enduser_id, data){
  data.idempotency = uuid.v1()
  return request({
    url: `/api/introducers/${enduser_id}`,
    method: "put",
    data: data
  });
}

export function getDownline(enduser_id){
  return request({
    url: `/api/introducers/${enduser_id}/downline`,
    method: "get"
  });
}

export function postDownline(enduser_id, data){
  data.idempotency = uuid.v1()
  return request({
    url: `/api/introducers/${enduser_id}/downline`,
    method: "post",
    data: data
  });
}


export function delDownline(enduser_id, data){
  data.idempotency = uuid.v1()
  return request({
    url: `/api/introducers/${enduser_id}/downline`,
    method: "delete",
    data: data
  });
}

export function getIncome(enduser_id, query){
  return request({
    url: `/api/introducers/${enduser_id}/income${obj2query(query)}`,
    method: "get"
  });
}

export function getIntroducerSummaryProject(project_uid, query) {
  return request({
    url: `/api/introducers/${project_uid}/summary${obj2query(query)}`,
    method: "get"
  });
}

export function reportIntroducerExcel(project_uid, query, filename) {
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  query['access_token'] = getToken()
  link.href = `${baseURL}/api/introducers/${project_uid}/excel${obj2query(query)}`
  if(filename){
    link.download = filename
  }
  link.click()
}

export function reportIntroducerPDF(project_uid, query, filename) {
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  query['access_token'] = getToken()
  link.href = `${baseURL}/api/introducers/${project_uid}/pdf${obj2query(query)}`
  if(filename){
    link.download = filename
  }
  link.click()
}

export function reportDownlineExcel(enduser_id, filename){
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  link.href = `${baseURL}/api/introducers/${enduser_id}/downline/excel?access_token=${getToken()}`
  if(filename){
    link.download = filename
  }
  link.click()
}

export function reportDownlinePDF(enduser_id, filename){
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  link.href = `${baseURL}/api/introducers/${enduser_id}/downline/pdf?access_token=${getToken()}`
  if(filename){
    link.download = filename
  }
  link.click()
}

export function reportIncomeExcel(enduser_id, query, filename){
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  query.access_token = getToken();
  link.href = `${baseURL}/api/introducers/${enduser_id}/income/excel${obj2query(query)}`
  if(filename){
    link.download = filename
  }
  link.click()

  delete query.access_token
}

export function reportIncomePDF(enduser_id, query, filename){
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  query.access_token = getToken();
  link.href = `${baseURL}/api/introducers/${enduser_id}/income/pdf${obj2query(query)}`
  if(filename){
    link.download = filename
  }
  link.click()
  delete query.access_token
}

export function reportIntroducerSummaryExcel(project_uid, query, filename) {
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  query['access_token'] = getToken()
  link.href = `${baseURL}/api/introducers/${project_uid}/summary/excel${obj2query(query)}`
  if (filename) {
    link.download = filename
  }
  link.click()
}

export function introducerBonusSummary(enduser_id){
  return request({
    url: `/api/introducers/${enduser_id}/bonus-summary`,
    method: "get"
  });
}

export function payTheBonusReferral(enduser_id, bankholder_id){
  return request({
    url: `/api/introducers/${enduser_id}/${bankholder_id}/paythebonusreferral`,
    method: "post"
  });
}

export function getDownlineReport(query){
  return request({
    url: `/api/introducers/downline/reports${obj2query(query)}`,
    method: "get"
  });
}

export function reportDownlineReportExcel(query, filename){
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  const exportQuery = { ...query, access_token: getToken() }
  link.href = `${baseURL}/api/introducers/downline/reports/export${obj2query(exportQuery)}`
  if(filename){
    link.download = filename
  }
  link.click()
}

export function introducerBonusSummaryExcel(enduser_id, filename){
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  const access_token = getToken()
  link.href = `${baseURL}/api/introducers/${enduser_id}/bonus-summary/excel?access_token=${access_token}`
  if(filename){
    link.download = filename
  }
  link.click()
}